import { AxiosInstance } from "axios"
import { GenericResponse } from "."

export interface ConsolidationModel {}

export interface ConsolidationListRequest {
    from: string
    to: string
}

export interface ConsolidationRequest {
    parcels_in_boxes: Record<string, any>
    suite_id: string
    consolidation_box_uuid?: string
}

export interface Measurments {
    height: string
    length: string
    width: string
    weight: string
}

export interface ConsolMeasurments extends Measurments {
    consolidation_box_uuid: string
}

export interface EconomyconsolMeasurments extends Measurments {
    box_temp_id: string
}

export interface MultiDimsUpdateRequest {
    consolidation_boxes_measurements: ConsolMeasurments[]
}

export interface EconomyconsolMasterLabelRequest {
    country: string
    boxes: Record<string, any[]>
    dims: EconomyconsolMeasurments[]
}

const consolidationApi = (apiInstance: AxiosInstance) => {
    const consolidationsList = async ({ warehouse }: { warehouse?: string }): Promise<GenericResponse> => {
        const res: Promise<GenericResponse> = apiInstance.get(
            `/parcels/get-consolidations?warehouse=${warehouse}`
        )
        return res
    }

    const consolidatedList = async ({ warehouse }: { warehouse?: string }): Promise<GenericResponse> => {
        const res: Promise<GenericResponse> = apiInstance.get(
            `/parcels/get-consolidated?warehouse=${warehouse}`
        )
        return res
    }

    const multiBoxConsolidation = async (
        consolidationRequestData: ConsolidationRequest
    ): Promise<GenericResponse> => {
        const res: Promise<GenericResponse> = apiInstance.post(
            `/parcels/consolidate-multibox`,
            consolidationRequestData
        )
        return res
    }

    const partialConsolidation = async (
        consolidationRequestData: ConsolidationRequest
    ): Promise<GenericResponse> => {
        const res: Promise<GenericResponse> = apiInstance.post(
            `/parcels/consolidate-partial`,
            consolidationRequestData
        )
        return res
    }

    const multiDimsUpdate = async (multiDimsUpdateData: MultiDimsUpdateRequest): Promise<GenericResponse> => {
        const res: Promise<GenericResponse> = apiInstance.post(
            `/parcels/update-multi-dims`,
            multiDimsUpdateData
        )
        return res
    }

    const cancelConsolidation = async (consolBoxUuid: string): Promise<GenericResponse> => {
        const res: Promise<GenericResponse> = apiInstance.post(`/parcels/unconsolidate/${consolBoxUuid}`)
        return res
    }

    const economyconsolsList = async ({ country }: { country?: string }): Promise<GenericResponse> => {
        const res: Promise<GenericResponse> = apiInstance.get(`/shopini/shipments/${country}`)
        return res
    }

    const economyconsolsMaterLabel = async (
        economyconsolMasterLabelData: EconomyconsolMasterLabelRequest
    ): Promise<GenericResponse> => {
        const res: Promise<GenericResponse> = apiInstance.post(
            `/shopini/master-label`,
            economyconsolMasterLabelData
        )
        return res
    }

    const countriesList = async (): Promise<GenericResponse> => {
        const res: Promise<GenericResponse> = apiInstance.get(`/shopini/shipment-countries`)
        return res
    }

    return {
        consolidationsList,
        consolidatedList,
        multiBoxConsolidation,
        partialConsolidation,
        multiDimsUpdate,
        cancelConsolidation,
        economyconsolsList,
        countriesList,
        economyconsolsMaterLabel
    }
}

export default consolidationApi
